import { lazy, type ComponentType } from "react";

const RELOAD_FLAG = "lazy-retry-reloaded";

function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;
  const msg = err instanceof Error ? err.message : String(err);
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /ChunkLoadError/i.test(msg) ||
    (err instanceof Error && err.name === "ChunkLoadError")
  );
}

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      if (!isChunkLoadError(err)) throw err;

      try {
        return await factory();
      } catch (err2) {
        if (!isChunkLoadError(err2)) throw err2;

        if (typeof window !== "undefined") {
          const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG);
          if (!alreadyReloaded) {
            sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
            window.location.reload();
            return new Promise<{ default: T }>(() => {});
          }
          sessionStorage.removeItem(RELOAD_FLAG);
        }
        throw err2;
      }
    }
  });
}
